import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'minToHour'
})
export class MinToHourPipe implements PipeTransform {

  transform(value: number): string {
    const hours = Math.floor(value/60);
    const minutesLeft = value % 60;
    let hr=hours>0?hours+'hr ':'';
    let min=minutesLeft +' min ';
    return hr + min;
  }

}
